// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidPackageDetailPage_BidContractRevisionFragmentDoc } from '../BidPackageDetailPage.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AwardBidModalQueryVariables = Types.Exact<{
  bidPackageId: Types.Scalars['ID']['input'];
}>;


export type AwardBidModalQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, isUnitBased: boolean, isPlanBasedV2: boolean, costCodes: Array<{ __typename?: 'CostCode', id: string }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, costCodes: Array<{ __typename?: 'CostCode', id: string }>, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, hasValidDrawTasks: boolean, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, isTaxExempt: boolean, totalCostInCents: number, userSet: boolean, bidItem?: { __typename?: 'BidItem', id: string, name: string, items: Array<{ __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } }> } | null | undefined, itemTemplateItem?:
            | { __typename?: 'ItemTemplateItemVersion', id: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } } }
            | { __typename?: 'ItemTemplateItem', id: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } } }
            | { __typename?: 'TakeoffLineItem', id: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } } }
            | { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } } }
           | null | undefined }>, draws: Array<{ __typename?: 'BidContractRevisionDraw', id: string, description?: string | null | undefined, isDeposit: boolean, amountInBasisPoints: number, globalPlanTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canReviseCosts: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canAddDraws: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEditDraws: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus }, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } }, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, bidPackage: { __typename?: 'BidPackage', id: string, isPlanBasedV2: boolean } } | null | undefined }> }, awards: Array<{ __typename?: 'BidPackageAward', id: string, costCode: { __typename?: 'CostCode', id: string }, primaryRevision: { __typename?: 'BidContractRevision', id: string }, secondaryRevision?: { __typename?: 'BidContractRevision', id: string } | null | undefined }>, overlappingBidPackages: Array<{ __typename?: 'BidPackage', id: string, latestAwards: Array<{ __typename?: 'BidPackageAward', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> }>, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, bidContract?: { __typename?: 'BidContract', id: string } | null | undefined }> } };

export type AwardBidModal_BidPackageFragment = { __typename?: 'BidPackage', id: string, isUnitBased: boolean, isPlanBasedV2: boolean, costCodes: Array<{ __typename?: 'CostCode', id: string }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, costCodes: Array<{ __typename?: 'CostCode', id: string }>, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, hasValidDrawTasks: boolean, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, isTaxExempt: boolean, totalCostInCents: number, userSet: boolean, bidItem?: { __typename?: 'BidItem', id: string, name: string, items: Array<{ __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } }> } | null | undefined, itemTemplateItem?:
          | { __typename?: 'ItemTemplateItemVersion', id: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } } }
          | { __typename?: 'ItemTemplateItem', id: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } } }
          | { __typename?: 'TakeoffLineItem', id: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } } }
          | { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } } }
         | null | undefined }>, draws: Array<{ __typename?: 'BidContractRevisionDraw', id: string, description?: string | null | undefined, isDeposit: boolean, amountInBasisPoints: number, globalPlanTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canReviseCosts: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canAddDraws: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEditDraws: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus }, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } }, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, bidPackage: { __typename?: 'BidPackage', id: string, isPlanBasedV2: boolean } } | null | undefined }> }, awards: Array<{ __typename?: 'BidPackageAward', id: string, costCode: { __typename?: 'CostCode', id: string }, primaryRevision: { __typename?: 'BidContractRevision', id: string }, secondaryRevision?: { __typename?: 'BidContractRevision', id: string } | null | undefined }>, overlappingBidPackages: Array<{ __typename?: 'BidPackage', id: string, latestAwards: Array<{ __typename?: 'BidPackageAward', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> }>, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, bidContract?: { __typename?: 'BidContract', id: string } | null | undefined }> };

export type AwardBidModal_BidPackageBidderFragment = { __typename?: 'BidPackageBidder', id: string, name: string, bidContract?: { __typename?: 'BidContract', id: string } | null | undefined };

export type SaveBidPackageAwardsMutationVariables = Types.Exact<{
  input: Types.SaveBidPackageAwardsInput;
}>;


export type SaveBidPackageAwardsMutation = { __typename?: 'Mutation', saveBidPackageAwards: { __typename?: 'SaveBidPackageAwardsResult', bidPackageAwards: Array<{ __typename?: 'BidPackageAward', id: string, primaryRevision: { __typename?: 'BidContractRevision', id: string }, secondaryRevision?: { __typename?: 'BidContractRevision', id: string } | null | undefined, costCode: { __typename?: 'CostCode', id: string } }> } };

export type BidPackageAwards_BidPackageAwardsFragment = { __typename?: 'BidPackageAward', id: string, primaryRevision: { __typename?: 'BidContractRevision', id: string }, secondaryRevision?: { __typename?: 'BidContractRevision', id: string } | null | undefined, costCode: { __typename?: 'CostCode', id: string } };

export const AwardBidModal_BidPackageBidderFragmentDoc = gql`
    fragment AwardBidModal_BidPackageBidder on BidPackageBidder {
  id
  name
  bidContract {
    id
  }
}
    `;
export const AwardBidModal_BidPackageFragmentDoc = gql`
    fragment AwardBidModal_BidPackage on BidPackage {
  id
  isUnitBased
  isPlanBasedV2
  costCodes {
    id
  }
  latestVersion {
    id
    costCodes {
      id
    }
  }
  awards {
    id
    costCode {
      id
    }
    primaryRevision {
      id
    }
    secondaryRevision {
      id
    }
  }
  overlappingBidPackages {
    id
    latestAwards {
      id
      costCode {
        id
        displayName
      }
    }
  }
  latestVersion {
    id
    latestBidContractRevisions {
      ...BidPackageDetailPage_BidContractRevision
    }
  }
  activeBidders {
    ...AwardBidModal_BidPackageBidder
  }
}
    ${BidPackageDetailPage_BidContractRevisionFragmentDoc}
${AwardBidModal_BidPackageBidderFragmentDoc}`;
export const BidPackageAwards_BidPackageAwardsFragmentDoc = gql`
    fragment BidPackageAwards_BidPackageAwards on BidPackageAward {
  id
  primaryRevision {
    id
  }
  secondaryRevision {
    id
  }
  costCode {
    id
  }
}
    `;
export const AwardBidModalDocument = gql`
    query AwardBidModal($bidPackageId: ID!) {
  bidPackage(id: $bidPackageId) {
    ...AwardBidModal_BidPackage
  }
}
    ${AwardBidModal_BidPackageFragmentDoc}`;

/**
 * __useAwardBidModalQuery__
 *
 * To run a query within a React component, call `useAwardBidModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardBidModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardBidModalQuery({
 *   variables: {
 *      bidPackageId: // value for 'bidPackageId'
 *   },
 * });
 */
export function useAwardBidModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AwardBidModalQuery, AwardBidModalQueryVariables> & ({ variables: AwardBidModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AwardBidModalQuery, AwardBidModalQueryVariables>(AwardBidModalDocument, options);
      }
export function useAwardBidModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AwardBidModalQuery, AwardBidModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AwardBidModalQuery, AwardBidModalQueryVariables>(AwardBidModalDocument, options);
        }
// @ts-ignore
export function useAwardBidModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AwardBidModalQuery, AwardBidModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AwardBidModalQuery, AwardBidModalQueryVariables>;
export function useAwardBidModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AwardBidModalQuery, AwardBidModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AwardBidModalQuery | undefined, AwardBidModalQueryVariables>;
export function useAwardBidModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AwardBidModalQuery, AwardBidModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AwardBidModalQuery, AwardBidModalQueryVariables>(AwardBidModalDocument, options);
        }
export type AwardBidModalQueryHookResult = ReturnType<typeof useAwardBidModalQuery>;
export type AwardBidModalLazyQueryHookResult = ReturnType<typeof useAwardBidModalLazyQuery>;
export type AwardBidModalSuspenseQueryHookResult = ReturnType<typeof useAwardBidModalSuspenseQuery>;
export type AwardBidModalQueryResult = ApolloReactCommon.QueryResult<AwardBidModalQuery, AwardBidModalQueryVariables>;
export const SaveBidPackageAwardsDocument = gql`
    mutation SaveBidPackageAwards($input: SaveBidPackageAwardsInput!) {
  saveBidPackageAwards(input: $input) {
    bidPackageAwards {
      ...BidPackageAwards_BidPackageAwards
    }
  }
}
    ${BidPackageAwards_BidPackageAwardsFragmentDoc}`;

/**
 * __useSaveBidPackageAwardsMutation__
 *
 * To run a mutation, you first call `useSaveBidPackageAwardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBidPackageAwardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBidPackageAwardsMutation, { data, loading, error }] = useSaveBidPackageAwardsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBidPackageAwardsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBidPackageAwardsMutation, SaveBidPackageAwardsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBidPackageAwardsMutation, SaveBidPackageAwardsMutationVariables>(SaveBidPackageAwardsDocument, options);
      }
export type SaveBidPackageAwardsMutationHookResult = ReturnType<typeof useSaveBidPackageAwardsMutation>;
export type SaveBidPackageAwardsMutationResult = ApolloReactCommon.MutationResult<SaveBidPackageAwardsMutation>;